import Swal from "sweetalert2";
import styled from 'styled-components';
import Panel from "@/shared/components/Panel";
import React, { useState, useEffect } from "react";
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const ClicksChartWrap = styled.div`
  margin-top: -30px;
`;

const HourlyUsage = () => {
    const [charData, setCharData] = useState();

    const handleModalClose = () => {
        setCharData(null);
    };

    const getHourlyUsage = () => {
        AdminInterface.instance.getHourlyUsage().then((response) => {
            setCharData(response.data);
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: error.response?.data?.detail,
            });
        });
    };

    useEffect(() => {
        getHourlyUsage();
    }, []);

    return (
        <Panel lg={6} xl={6} md={12} title='Hourly Usage' subhead='Relative frequency of requests per hour' dismissButton={() => handleModalClose()} refreshRequest={() => getHourlyUsage()}>
            {charData && <ClicksChartWrap dir="ltr">
                <ResponsiveContainer height={300}>
                    <BarChart data={charData} margin={{ top: 5, right: 30, left: 20, bottom: 20 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="hour" label={{ value: 'Hour of day', position: 'bottom' }}/>
                        <YAxis label={{ value: '% of requests', angle: -90, position: 'insideLeft' }} />
                        <Tooltip />
                        <Bar type="monotone" dataKey="count" fill="#48b5ff"/>
                    </BarChart>
                </ResponsiveContainer>
            </ClicksChartWrap>}
        </Panel>
    );
};

export default HourlyUsage;